import { GenericStatus, LeaderboardConfigInput } from 'api';
import { ARRAY, NULL } from 'constants/index';

export const createLeaderboardResponse = (values: LeaderboardConfigInput) => ({
  createUpdateLeaderboardConfig: {
    ...values,
    id: '-1',
    created_at: '-1',
    all_users: false,
    description: NULL,
    segment_ids: ARRAY,
    segments: ARRAY,
    start_at: NULL,
    end_at: NULL,
    leaderboard_status: GenericStatus.Disabled,
    __typename: 'LeaderboardConfig',
  },
});
